import formComponent from '@/util/proto/formComponent'
import global from '@/util/mixin/global'
import { conv } from '@/util'

const result = [
  {value:0 , label:'通过'},
  {value:1 , label:'拒绝'},
]

export default {
  extends: formComponent ,
  mixins:[global],
  props:['id','branchId'],
  data() {
    return {
      loading:false,
      repairUsers:[],
      formData: {
        repairSiteId: {
          rules:[
            { required: true, type:'number',message: '请选择维修站点', trigger: 'blur,change' },
          ]
        },
        repairUserId:{
          rules:[
            { required: false, type:'number',message: '请选择维修师', trigger: 'blur,change' },
          ]
        }
      }
    }
  },
  created(){
    this.$watch('branchId' , function(nv){
      if(nv){
        this.handleChangeSite(nv)
        this.$setFormData({repairSiteId:nv})
      }
    } , {immediate:true})
  },
  computed:{
    branchs(){
      return new Promise((resolve , reject) => {
        if( this.isASS ){
          return this.$request.assBranchCurrent().then( resp => {
            resolve( [{value:resp.data.id , label:resp.data.repairSiteName}] )
          })
        }else{
          return this.$request.assBranchsAll().then( resp => {
            resolve( resp.data.map(i => ({value:i.id , label:i.repairSiteName})))
          })
        }
      })
    }
  },
  methods:{
    save(d){
      let ids = Array.isArray(this.id) ? this.id : (this.id !== undefined && this.id !== null) ? [this.id] : []

      const params = { ids , ...d }

      this.loading = true

      this.$request.stdInstallationAssign(params).then(resp => {
        this.loading = false
        
        if(resp.code){
          this.$Message.error(resp.msg)
        }else{
          this.$Message.success('分配成功')
          this.$emit('ok')
        }
      })  
    },
    handleChangeSite(v){
      if(v !== undefined && v !== null){
        this.$request.assEmpolyeesBySite(v).then(resp => {
          this.repairUsers = conv(resp.data || [] , { 'imgPath:icon':'img'}).map(i => ({
            icon:i.icon , value:i.id , label:i.repairUserName
          }))
        })
      }
    }
  },
  render(){
    const { formData , loading , repairUsers , branchId } = this
    const branchDisabled = this.isASS || !!this.branchId
    const selectSlots = {
      option:(data)=>{
        return <div style="display:flex;align-items:center;">
          <Avatar size="large" src={data.icon} style="margin-right:6px;" />
          <div>
            <div style="margin-bottom:5px;">
              <span>{data.repairUserName}</span>
              <span style="margin-left:8px;color:rgba(0, 0, 0, 0.45);font-size:10px;">{data.phone}</span>
            </div>
            <span style="color:rgba(0, 0, 0, 0.45);font-size:12px;display:flex;align-items:center;">
              
            </span>
          </div>
        </div>
      }
    }
    return (
      <div>
        <div class="modal-body">
          <sl-form label-width={100}>
            <sl-form-item label="维修站点">
              <sl-select dict={this.branchs} on-change={this.handleChangeSite} v-decorator={formData.repairSiteId} auto-fill={this.isASS} disabled={branchDisabled} />
            </sl-form-item>
            <sl-form-item label="维修师">
              <sl-select dict={repairUsers} v-decorator={formData.repairUserId} />
            </sl-form-item>
          </sl-form>
        </div>
        <div class="modal-footer">
          <Button loading={loading} on-click={this.$handleSubmit} type="primary">确定</Button>
        </div>
      </div>
    )
  }
}